import React, { useEffect, useState, useCallback, useRef, useContext, useImperativeHandle } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { parseISO } from 'date-fns';

import KidsIcon from '../../../assets/icons/girl_s.png';
import MissionsIcon from '../../../assets/icons/missions_green.png';

import Search from '../../../components/Search';
import Modal from '../../../components/Modal';
import Loader from '../../../components/Loader';
import AddChild from '../../../components/AddChild';
import ResponsiveFooter from '../../../components/ResponsiveFooter';

import { SearchContext } from '../../../hooks/SearchContext';
import { useListChildren } from '../../../hooks/ParentContext';

import api from '../../../services/api';

import { Container, Content } from './styles';

const AdminDashboard = () => {
  const { toggleChild } = useListChildren();
  const { filteredList, notFound } = useContext(SearchContext);
  const [toggleModal, setToggleModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [childrenState, setChildrenState] = useState([]);
  //!infite scroll
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(false);

  const token = localStorage.getItem("@Ocariot:token");
  const observer = useRef(null);

  const lastChildElementRef = useCallback(
    (item) => {
      if (loading) return;

      if (total > 0 && childrenState.length === total) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) setPage(page + 1);
      });

      if (item) observer.current.observe(item);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading, hasMore]
  );

  const loadChildren = () => {
    setLoading(true);
    api.get('child', {
      params: {
        sort: { field: "_id", order: 1 },
        pagination: { page, perPage: 11 },
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      setTotal(res.data.total);
      setHasMore(res.data.data.length > 0);
      setChildrenState(childrenState => [...childrenState, ...res.data.data]);
      setLoading(false);
    }).catch((err) => {
      toast.error("Erro ao carregar crianças");
      setLoading(false);
      console.log(err);
    });
  }

  useEffect(() => {
    loadChildren();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  return (
    <>
      <Modal
        width={600}
        height={600}
        show={toggleModal}
        onClose={() => setToggleModal(false)}
        title="Adicionar criança"
      >
        <AddChild setModalState={setToggleModal} />
      </Modal>
      <Container>
        <Content>
          <header>
            <Link to="/dashboard">
              <div className="flex-div">
                <img src={KidsIcon} alt="Crianças" />
                <h2>Crianças</h2>
              </div>
            </Link>
            <Link to="/missions">
              <div className="flex-div">
                <img src={MissionsIcon} alt="Crianças" />
                <h2>Missões</h2>
              </div>
            </Link>

          </header>
          <div className="body">
            <div className="first-line-body">
              <button type="button" className="default-bnt" onClick={() => setToggleModal(true)}>
                Adicionar criança
              </button>
              <Search placeholder="Buscar criança..." component="child" qField="nickname" />
            </div>
            <br />
            <p>Total de crianças cadastradas: <strong>{total}</strong></p>
            {(loading && childrenState.length === 0) ? (
              <div className="loader-div">
                <Loader color="blue" />
              </div>

            ) : (
              <div className="scroll-body">

                {(filteredList.length === 0 && !notFound) ? (
                  <table id="childrens-table">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Sexo</th>
                        <th>Classe</th>
                        <th>Idade</th>
                      </tr>
                    </thead>
                    <tbody >
                      {childrenState.map((child, idx) => (
                        <tr ref={childrenState.length === idx + 1 ? lastChildElementRef : null} key={child._id} onClick={() => toggleChild(child)}>
                          <td>{child.nickname}</td>
                          <td>{child.genre}</td>
                          <td>{child.grade}</td>
                          <td style={{ textTransform: "lowercase" }}>{parseInt(new Date().getFullYear()) - parseInt(parseISO(child.birth).getFullYear())} anos</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : !notFound ? (
                  <table id="childrens-table">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Sexo</th>
                        <th>Classe</th>
                        <th>Idade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredList.map((child, idx) => (
                        <tr ref={childrenState.length === idx + 1 ? lastChildElementRef : null} key={child._id} onClick={() => toggleChild(child)}>
                          <td>{child.nickname}</td>
                          <td>{child.genre}</td>
                          <td>{child.grade}</td>
                          <td style={{ textTransform: "lowercase" }}>{parseInt(new Date().getFullYear()) - parseInt(parseISO(child.birth).getFullYear())} anos</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>Não foram encontradas crianças</p>
                )}

                {loading && (
                  <>
                    <br />
                    <Loader color="blue" />
                  </>
                )}

                {(!loading && (childrenState.length === 0)) && (<p>Ainda não foram cadastradas crianças</p>)}
              </div>
            )}

          </div>
          {!loading && <ResponsiveFooter />}
        </Content>
      </Container>
    </>
  );
}

export default AdminDashboard;